import { detectMobileOperatingSystem } from '../../common/detectDeviceType'

import { bankKeys, BankSystemDeeplinksMap } from './constants'

const formatPhoneNumber = (phone) => {
    try {
        return encodeURIComponent(phone.replace(/^(?:\+\.? ?)?/i, '+'))
    } catch {
        return phone
    }
}

export const openDeeplinksListWithReload = () => {
    return new Promise((resolve, reject) => {
        const clear = (succeeded) => {
            sessionStorage.removeItem('nextDeeplinkId')
            sessionStorage.removeItem('deeplinksInfo')

            if (succeeded) {
                sessionStorage.setItem('deeplinksInProgress', false)

                setTimeout(() => {
                    sessionStorage.removeItem('deeplinksInProgress')
                }, 1000)
            }
        }

        try {
            if (!sessionStorage.getItem('deeplinksInfo')) {
                resolve()

                return
            }

            const {
                phoneNumber, cardNumber, accountNumber, paymentInfoAmount, bank, method
            } = JSON.parse(sessionStorage.getItem('deeplinksInfo'))
            const osType = detectMobileOperatingSystem()

            const deeplinksList = BankSystemDeeplinksMap[bank]?.[osType]?.[method]

            const replaceVariables = (link) => {
                const formattedPhoneNumber = bank === bankKeys.tinkoff
                    ? formatPhoneNumber(phoneNumber)
                    : phoneNumber

                return link
                    .replace('{phoneNumber}', formattedPhoneNumber)
                    .replace('{amount}', paymentInfoAmount)
                    .replaceAll('{cardNumber}', cardNumber || '')
                    .replace('{accountNumber}', accountNumber || '')
            }

            const id = +sessionStorage.getItem('nextDeeplinkId') || 0
            if (deeplinksList?.length && !isNaN(id) && deeplinksList[id]) {
                window.location.href = replaceVariables(deeplinksList[id])
                sessionStorage.setItem('nextDeeplinkId', id + 1)

                setTimeout(() => {
                    window.location.reload()
                }, 50)
            } else {
                clear(true)
                resolve()
            }
        } catch {
            clear()
            reject()
        }
    })
}
